import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_incomes/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchExportInvoice(agro_exporter_id, export_invoice_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_incomes/show_export_invoice/${agro_exporter_id}/fetch_export_invoice/${export_invoice_id}`
    );
  },
  fetchInvoicePayments(agro_exporter_id, export_invoice_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_incomes/show_export_invoice/${agro_exporter_id}/fetch_invoice_payments/${export_invoice_id}`
    );
  }
};
